import {MandarkResourceInterface} from '../Mandark.interface';

export class StudentIntervalStatsInterface extends MandarkResourceInterface {
  getIntervalData() {
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    return this._data.getIn(['data', 'intervals']);
  }
}
